# Generated by https://pagedraw.io/pages/4820
React = require 'react'


render = ->
    React.createElement("div", {"className": "sketchimporter"},
        React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
            @import url('https://fonts.googleapis.com/css?family=Lato:');
            
            .sketchimporter {
                display: flex;
                flex-grow: 1;
            }
            
            .sketchimporter-error-1 {
                display: flex;
                flex-direction: column;
                padding-top: 24px;
                padding-bottom: 38px;
                background: #FFFFFF;
                flex-grow: 1;
            }
            
            .sketchimporter-0-0-0 {
                display: flex;
                padding-left: 28px;
                padding-right: 184px;
            }
            
            .sketchimporter-error_importing_file_-8 {
                width: 356px;
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: rgb(239, 80, 80);
                font-size: 14px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
            }
            
            .sketchimporter-0-0-1 {
                display: flex;
                margin-top: 21px;
                padding-left: 28px;
                padding-right: 20px;
            }
            
            .sketchimporter-check_that_your_sketch_file_is_correctly_formed_if_this_problem_persists_please_send_your_sketch_file_to_the_pagedraw_team_at_team_pagedraw_io_-7 {
                width: 520px;
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: #000000;
                font-size: 14px;
                line-height: 19px;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
            }
            
            .sketchimporter-importing-7 {
                display: flex;
                flex-direction: column;
                padding-top: 2px;
                padding-bottom: 16px;
                background: #FFFFFF;
                flex-grow: 1;
            }
            
            .sketchimporter-1-0-0 {
                display: flex;
            }
            
            .sketchimporter-1-0-0-0 {
                height: 0px;
                flex-grow: 0.4978540772532189;
                flex-basis: 0px;
            }
            
            .sketchimporter-image-7 {
                width: 101.99999999999999px;
                height: 101.99999999999999px;
                flex-shrink: 0;
                border-width: 0px;
            }
            
            .sketchimporter-1-0-0-2 {
                height: 0px;
                flex-grow: 0.5021459227467812;
                flex-basis: 0px;
            }
            
            .sketchimporter-1-0-1 {
                display: flex;
                padding-left: 117px;
                padding-right: 118px;
            }
            
            .sketchimporter-1-0-1-0 {
                flex-shrink: 0;
                display: flex;
            }
            
            .sketchimporter-text-0 {
                width: 333px;
                font-family: "Lato", sans-serif;
                color: rgb(19, 53, 148);
                font-size: 14px;
                line-height: 16px;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: underline;
                text-align: center;
                word-wrap: break-word;
                flex-grow: 1;
            }
            
            .sketchimporter-initial-9 {
                display: flex;
                flex-direction: column;
                background: #FFFFFF;
                flex-grow: 1;
            }
            
            .sketchimporter-2-0-0 {
                display: flex;
            }
            
            .sketchimporter-rectangle-6 {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                flex-basis: 0px;
                min-height: fit-content;
                padding-top: 38px;
                padding-bottom: 38px;
                border-radius: 7px;
                background: rgb(245, 245, 245);
                border: 3px solid rgb(214, 214, 214);
            }
            
            .sketchimporter-2-0-0-0-0 {
                display: flex;
                justify-content: center;
            }
            
            .sketchimporter-drop_your_sketch_file_here_-4 {
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: rgb(26, 23, 116);
                font-size: 18px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: bold;
                font-style: normal;
                text-decoration: none;
                text-align: left;
                word-wrap: break-word;
                padding-right: 0.265625px;
            }
            
            .sketchimporter-2-0-0-0-1 {
                display: flex;
                margin-top: 25px;
            }
            
            .sketchimporter-2-0-0-0-1-0 {
                height: 0px;
                flex-grow: 0.5013774104683195;
                flex-basis: 0px;
            }
            
            .sketchimporter-or_click_to_select_a_file_to_upload_-4 {
                flex-shrink: 0;
                font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
                color: #000000;
                font-size: 14px;
                line-height: normal;
                letter-spacing: 0px;
                font-weight: normal;
                font-style: normal;
                text-decoration: none;
                text-align: center;
                word-wrap: break-word;
                padding-right: 0.125px;
            }
            
            .sketchimporter-2-0-0-0-1-2 {
                height: 0px;
                flex-grow: 0.4986225895316804;
                flex-basis: 0px;
            }
            
            * {
                box-sizing: border-box;
            }
            
            body {
                margin: 0;
            }
            
            button:hover {
                cursor: pointer;
            }
            
            a {
                text-decoration: none;
                color: inherit;
            }
            
            .pd-onhover-parent >.pd-onhover {
                display: none;
            }
            
            .pd-onhover-parent:hover > * {
                display: none;
            }
            
            .pd-onhover-parent:hover > .pd-onhover {
                display: flex;
            }
            
            .pd-onactive-parent > .pd-onactive {
                display: none;
            }
            
            .pd-onactive-parent:active > * {
                display: none;
            }
            
            .pd-onactive-parent:active > .pd-onactive {
                display: flex;
            }
            
            .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                display: none;
            }
        """)}),  
        ( if ((if @props.error? then 'Error' else if @props.importing then 'Importing' else 'Initial') == "Error")
            React.createElement("div", {"className": "sketchimporter-error-1"},
                React.createElement("div", {"className": "sketchimporter-0-0-0"},
                    React.createElement("div", {"className": "sketchimporter-error_importing_file_-8"}, """
                        Error importing file.
""")
                ),
                React.createElement("div", {"className": "sketchimporter-0-0-1"},
                    React.createElement("div", {"className": "sketchimporter-check_that_your_sketch_file_is_correctly_formed_if_this_problem_persists_please_send_your_sketch_file_to_the_pagedraw_team_at_team_pagedraw_io_-7"},
                        ( @props.error )
                    )
                )
            )
        ),
        ( if ((if @props.error? then 'Error' else if @props.importing then 'Importing' else 'Initial') == "Importing")
            React.createElement("div", {"className": "sketchimporter-importing-7"},
                React.createElement("div", {"className": "sketchimporter-1-0-0"},
                    React.createElement("div", {"className": "sketchimporter-1-0-0-0"}),  
                    React.createElement("img", {"src": "https://complex-houses.surge.sh/59ec0968-b6e3-4a00-b082-932b7fcf41a5/loading.gif", "className": "sketchimporter-image-7"}),  
                    React.createElement("div", {"className": "sketchimporter-1-0-0-2"}) 
                ),
                React.createElement("div", {"className": "sketchimporter-1-0-1"},
                    React.createElement("a", {"href": "https://documentation.pagedraw.io/sketch/", "target": "_blank", "className": "sketchimporter-1-0-1-0"},
                        React.createElement("div", {"className": "sketchimporter-text-0"}, """
                            Read more about Sketch importing while you wait
""")
                    )
                )
            )
        ),
        ( if ((if @props.error? then 'Error' else if @props.importing then 'Importing' else 'Initial') == "Initial")
            React.createElement("div", {"className": "sketchimporter-initial-9"},
                React.createElement("div", {"className": "sketchimporter-2-0-0"},
                    React.createElement("div", {"className": "sketchimporter-rectangle-6"},
                        React.createElement("div", {"className": "sketchimporter-2-0-0-0-0"},
                            React.createElement("div", {"className": "sketchimporter-drop_your_sketch_file_here_-4"}, """
                                Drop your Sketch file here
""")
                        ),
                        React.createElement("div", {"className": "sketchimporter-2-0-0-0-1"},
                            React.createElement("div", {"className": "sketchimporter-2-0-0-0-1-0"}),  
                            React.createElement("div", {"className": "sketchimporter-or_click_to_select_a_file_to_upload_-4"}, """
                                or click to select a file to upload
"""),
                            React.createElement("div", {"className": "sketchimporter-2-0-0-0-1-2"}) 
                        )
                    )
                )
            )
        )
    )

module.exports = (props) -> render.apply({props})



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/sketch-importer.cjsx